import defaultSettings from '@/settings';
import getPageTitle from '@/utils/get-page-title';
var showSettings = defaultSettings.showSettings,
  fixedHeader = defaultSettings.fixedHeader,
  sidebarLogo = defaultSettings.sidebarLogo,
  layoutColor = defaultSettings.layoutColor,
  roleType = defaultSettings.roleType,
  userinfo = defaultSettings.userinfo,
  roleTypeArr = defaultSettings.roleTypeArr,
  menuArr = defaultSettings.menuArr,
  iframeUrl = defaultSettings.iframeUrl,
  breadcrumb = defaultSettings.breadcrumb,
  menuactivehome = defaultSettings.menuactivehome,
  index = defaultSettings.index,
  iframeKey = defaultSettings.iframeKey;
var states = {
  showSettings: showSettings,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  layoutColor: layoutColor,
  roleType: roleType,
  userinfo: userinfo,
  roleTypeArr: roleTypeArr,
  menuArr: menuArr,
  iframeUrl: iframeUrl,
  breadcrumb: JSON.parse(sessionStorage.getItem('resourcePath')) || breadcrumb,
  menuactivehome: menuactivehome,
  index: index,
  iframeKey: iframeKey
};
var mutations = {
  CHANGE_SETTING: function CHANGE_SETTING(state, _ref) {
    var key = _ref.key,
      value = _ref.value;
    // eslint-disable-next-line no-prototype-builtins
    if (Object.prototype.hasOwnProperty.call(state, key)) {
      state[key] = value;
    }
  },
  RESET_STATE: function RESET_STATE(state) {
    Object.assign(state, defaultSettings);
  }
};
var actions = {
  changeSetting: function changeSetting(_ref2, data) {
    var commit = _ref2.commit;
    commit('CHANGE_SETTING', data);
  },
  clearNavStatus: function clearNavStatus(_ref3, title) {
    var commit = _ref3.commit;
    sessionStorage.removeItem('defaultactivemenu');
    commit('CHANGE_SETTING', {
      key: 'iframeUrl',
      value: null
    });
    commit('CHANGE_SETTING', {
      key: 'index',
      value: null
    });
    document.title = getPageTitle(title);
  },
  resetState: function resetState(_ref4) {
    var commit = _ref4.commit;
    commit('RESET_STATE');
  }
};
export default {
  namespaced: true,
  state: states,
  mutations: mutations,
  actions: actions
};